/**
 * 학습통계 안의 통계 항목 1칸(완료한 오늘의 문제 / 완료한 문제 / 완료한 챕터).
 *
 * LearningStatistics 가 3개를 나란히 렌더한다. 클릭 동작은 부모가 넘긴 onClick 에
 * 전부 위임한다(체험용 계정 접근 제한 모달을 열지, 실제 이동을 시킬지는 이 컴포넌트가 모른다).
 */
import React from "react";

interface StatisticsCardProps {
  title: string;
  sub: string;
  value: number;
  onClick: () => void;
}

/** 통계 카드 1칸. title/sub 두 줄 라벨과 value(개수)를 보여준다. */
const StatisticsCard: React.FC<StatisticsCardProps> = ({
  title,
  sub,
  value,
  onClick,
}) => {
  return (
    <div onClick={onClick} className="statistics-card w-2/6 cursor-pointer">
      <div className="text-15 text-body font-medium mb-[10px]">
        <div>{title}</div>
        <div>{sub}</div>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-20 text-primary font-bold font-heading">{value}</span>
        <span className="text-14 text-strong font-medium">개</span>
      </div>
    </div>
  );
};

export default StatisticsCard;
